(function () {
  'use strict';

  var closeTimer = null;
  var CLOSE_DELAY = 150;
  var lastOpenTrigger = null;

  function getTopLevelNavFocusables() {
    var nav = document.querySelector('.header__inline-menu > ul.list-menu--inline');
    if (!nav) return [];

    return Array.from(nav.children)
      .map(function (item) {
        return item.querySelector('.mega-menu__trigger, a.header__menu-item');
      })
      .filter(Boolean);
  }

  function getPanelFocusables(panel) {
    if (!panel) return [];

    return Array.from(
      panel.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"])')
    );
  }

  function setPanelInert(panel, inert) {
    if (!panel) return;

    if (inert) {
      panel.setAttribute('inert', '');
    } else {
      panel.removeAttribute('inert');
    }
  }

  function closeAllMegaMenus() {
    document.querySelectorAll('.mega-menu__content--open').forEach(function (panel) {
      panel.classList.remove('mega-menu__content--open');
      panel.setAttribute('aria-hidden', 'true');
      setPanelInert(panel, true);
    });
    document.querySelectorAll('.mega-menu--open').forEach(function (item) {
      item.classList.remove('mega-menu--open');
    });
    document.querySelectorAll('.mega-menu__trigger[aria-expanded="true"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function cancelClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = setTimeout(closeAllMegaMenus, CLOSE_DELAY);
  }

  function menuItemHasFocus(menuItem) {
    return menuItem.contains(document.activeElement);
  }

  function openMegaMenu(menuItem) {
    var trigger = menuItem.querySelector('.mega-menu__trigger');
    var panel = menuItem.querySelector('.mega-menu__content');
    if (!trigger || !panel) return;

    cancelClose();
    closeAllMegaMenus();
    menuItem.classList.add('mega-menu--open');
    panel.classList.add('mega-menu__content--open');
    panel.setAttribute('aria-hidden', 'false');
    setPanelInert(panel, false);
    trigger.setAttribute('aria-expanded', 'true');
    lastOpenTrigger = trigger;
  }

  function focusAdjacentTopLevel(current, direction) {
    var items = getTopLevelNavFocusables();
    var index = items.indexOf(current);
    if (index === -1) return;

    var nextIndex = index + direction;
    if (nextIndex < 0 || nextIndex >= items.length) return;

    cancelClose();
    items[nextIndex].focus();
  }

  function initMegaMenu() {
    var menuItems = document.querySelectorAll('[data-mega-menu]');
    if (!menuItems.length) return;

    document.addEventListener('focusin', function (event) {
      var openItem = document.querySelector('.mega-menu--open');
      if (!openItem) return;

      if (openItem.contains(event.target)) {
        cancelClose();
        return;
      }

      cancelClose();
      closeAllMegaMenus();
    });

    menuItems.forEach(function (menuItem) {
      var trigger = menuItem.querySelector('.mega-menu__trigger');
      var panel = menuItem.querySelector('.mega-menu__content');
      if (!trigger || !panel) return;

      setPanelInert(panel, true);

      menuItem.addEventListener('mouseenter', function () {
        openMegaMenu(menuItem);
      });

      menuItem.addEventListener('mouseleave', function () {
        if (menuItemHasFocus(menuItem)) return;
        scheduleClose();
      });

      panel.addEventListener('mouseenter', function () {
        openMegaMenu(menuItem);
      });

      panel.addEventListener('mouseleave', function () {
        if (menuItemHasFocus(menuItem)) return;
        scheduleClose();
      });

      trigger.addEventListener('focus', function () {
        openMegaMenu(menuItem);
      });

      trigger.addEventListener('keydown', function (event) {
        var panelLinks = getPanelFocusables(panel);
        var topLevelItems = getTopLevelNavFocusables();

        if (event.key === 'Tab' && !event.shiftKey && panelLinks.length) {
          event.preventDefault();
          openMegaMenu(menuItem);
          panelLinks[0].focus();
          return;
        }

        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            openMegaMenu(menuItem);
            if (panelLinks[0]) panelLinks[0].focus();
            break;
          case 'ArrowUp':
            event.preventDefault();
            closeAllMegaMenus();
            break;
          case 'ArrowRight':
            event.preventDefault();
            focusAdjacentTopLevel(trigger, 1);
            break;
          case 'ArrowLeft':
            event.preventDefault();
            focusAdjacentTopLevel(trigger, -1);
            break;
          case 'Home':
            event.preventDefault();
            if (topLevelItems[0]) topLevelItems[0].focus();
            break;
          case 'End':
            event.preventDefault();
            if (topLevelItems.length) topLevelItems[topLevelItems.length - 1].focus();
            break;
          case 'Escape':
            event.preventDefault();
            cancelClose();
            closeAllMegaMenus();
            trigger.focus();
            break;
        }
      });

      panel.addEventListener('keydown', function (event) {
        var panelLinks = getPanelFocusables(panel);
        var currentIndex = panelLinks.indexOf(document.activeElement);

        if (event.key === 'Tab' && event.shiftKey && currentIndex === 0) {
          event.preventDefault();
          trigger.focus();
          return;
        }

        switch (event.key) {
          case 'Escape':
            event.preventDefault();
            cancelClose();
            closeAllMegaMenus();
            trigger.focus();
            break;
          case 'ArrowUp':
            if (currentIndex === 0) {
              event.preventDefault();
              trigger.focus();
            }
            break;
          case 'Home':
            event.preventDefault();
            if (panelLinks[0]) panelLinks[0].focus();
            break;
          case 'End':
            event.preventDefault();
            if (panelLinks.length) panelLinks[panelLinks.length - 1].focus();
            break;
        }
      });
    });

    getTopLevelNavFocusables().forEach(function (link) {
      if (link.classList.contains('mega-menu__trigger')) return;

      link.addEventListener('keydown', function (event) {
        var topLevelItems = getTopLevelNavFocusables();

        switch (event.key) {
          case 'ArrowRight':
            event.preventDefault();
            focusAdjacentTopLevel(link, 1);
            break;
          case 'ArrowLeft':
            event.preventDefault();
            focusAdjacentTopLevel(link, -1);
            break;
          case 'Home':
            event.preventDefault();
            if (topLevelItems[0]) topLevelItems[0].focus();
            break;
          case 'End':
            event.preventDefault();
            if (topLevelItems.length) topLevelItems[topLevelItems.length - 1].focus();
            break;
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!document.querySelector('.mega-menu__content--open')) return;

      event.preventDefault();
      cancelClose();
      closeAllMegaMenus();

      if (lastOpenTrigger) {
        lastOpenTrigger.focus();
      }
    });
  }

  function initDrawerAccordions() {
    var accordions = document.querySelectorAll('.menu-drawer__accordion');
    accordions.forEach(function (accordion) {
      accordion.addEventListener('toggle', function () {
        if (!accordion.open) return;
        var drawer = accordion.closest('header-drawer');
        if (!drawer) return;
        drawer.querySelectorAll('.menu-drawer__accordion').forEach(function (other) {
          if (other !== accordion && other.open) {
            other.removeAttribute('open');
          }
        });
      });
    });
  }

  function initDrawerClose() {
    document.querySelectorAll('.menu-drawer-close').forEach(function (button) {
      button.addEventListener('click', function () {
        var summary = document.querySelector('.header__icon--menu');
        if (summary) summary.click();
      });
    });
  }

  function initHelpPopup() {
    var heading = document.querySelector('.header--inline .cl-heading');
    var content = document.querySelector('.header--inline .cl-content');
    var closeBtn = document.querySelector('.header--inline .cl-content-inner span');
    if (!heading || !content) return;

    if (window.matchMedia('(max-width: 767px)').matches) {
      heading.addEventListener('click', function () {
        content.classList.add('active');
        content.style.display = 'block';
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          content.classList.remove('active');
          content.style.display = 'none';
        });
      }
    }
  }

  function syncHeaderHeight() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  function initHeaderHeight() {
    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight);

    if (typeof ResizeObserver === 'undefined') return;

    var header = document.querySelector('.section-header');
    if (!header) return;

    var observer = new ResizeObserver(syncHeaderHeight);
    observer.observe(header);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMegaMenu();
    initDrawerAccordions();
    initDrawerClose();
    initHelpPopup();
    initHeaderHeight();
  });

  document.addEventListener('header:close-menus', function () {
    cancelClose();
    closeAllMegaMenus();
  });
  window.HeaderMenu = { closeAll: closeAllMegaMenus };
})();
